import axiosInstance from "./axios";
import { errorToast } from "../shared/Toast";

const read = async (url, params, fallback, label) => {
  try {
    const res = await axiosInstance.get(url, { params });
    if (res?.data && !res.data.isError) return res.data.data;
    errorToast(res?.data?.message ?? `Error loading ${label}`);
    return fallback;
  } catch (error) {
    errorToast(error?.response?.data?.message ?? error?.message ?? `Error loading ${label}`);
    return fallback;
  }
};

export const getSmsUsageSummary = (params) =>
  read("/api/admin/smsUsage/summary", params, { rows: [] }, "SMS usage summary");

export const getSmsLogs = (params) =>
  read("/api/admin/smsUsage/logs", params, { rows: [], total: 0, page: 1, totalPages: 1 }, "SMS logs");
